import {observable} from "mobx";
import {miniPersistStore} from "./MiniPersistStore";
import * as H from "history";
import {message} from "antd";
import {consoleApi} from "../apiMiddleware";
import { getCurrentLan } from "@netless/i18n-react-router";
export type LoginResData = {
    code: number;
    data: any;
};

export type ResPutData = {
    code: number,
    data: {
        ok: string,
    },
};

export class LoginStore {

    @observable
    public loginLoadingState: boolean = false;
    @observable
    public updateLoadingState: boolean = false;
    @observable
    public loginByPhoneLoadingState: boolean = false;
    @observable
    public resetPasswordLoadingState: boolean = false;
    @observable
    public resetPasswordState: boolean = false;

    public async login(history: H.History, email: string, password: string): Promise<void> {
        try {
            this.loginLoadingState = true;
            const resp = await consoleApi.user.getUserData(email, password);
            console.log(resp);
            miniPersistStore.token = resp.data.token;
            miniPersistStore.adminEnable = resp.data.admin.emailVerifyed;
            if (!resp.data.admin.emailVerifyed) {
                await this.sendMail();
                history.push(`/register/step-two/${email}/`);
            } else {
                miniPersistStore.isLogin(history);
            }
        } catch (err) {
            message.error(err.message);
        } finally {
            this.loginLoadingState = false;
        }

    }

    public async updateInf(history: H.History, userName: string, companyName: string, companyAddress: string, token: string, isInConsole?: boolean): Promise<void> {
        try {
            this.updateLoadingState = true;
            const respUserInf: ResPutData = await consoleApi.user.upDateUserInf(userName, token);
            const respCompanyInf: ResPutData = await consoleApi.user.upDateCompanyInf(companyName, companyAddress, token);
            const isEnglish: boolean = getCurrentLan() === "en";
            if (respUserInf.code === 200 && respCompanyInf.code === 200) {
                if (!isInConsole) {
                    history.push("/");
                    message.success(isEnglish ? "registration success" : "注册成功");
                } else {
                    message.success(isEnglish ? "update completed" : "更新成功");
                }
            } else {
                if (respUserInf.code !== 200) {
                    message.error(isEnglish ? "Error updating user information" : "更新用户信息出错");
                } else {
                    message.error(isEnglish ? "Error updating company information" : "更新公司信息出错");
                }
            }

        } catch (err) {
            message.error(err.message);
        } finally {
            this.updateLoadingState = false;
        }

    }

    private sendMail = async (email?: string): Promise<void> => {
        let res;
        try {
            if (email) {
                res = await consoleApi.user.loginResetPassword(email);
            } else {
                res = await consoleApi.user.sendEmail();
            }
            if (res.code === 200) {
                const isEnglish: boolean = getCurrentLan() === "en";
                message.success(isEnglish ? "Send verification email successfully" : "发送验证邮件成功");
            }
        } catch (err) {
            message.error(err.message);
        }
    }

    public async loginResetPassword(history: H.History, email: string): Promise<void> {
        this.resetPasswordLoadingState = true;
        try {
            const res = await consoleApi.user.loginResetPassword(email);
            if (res.code === 200) {
                history.push(`/email-account-verification-step-two/${email}/`);
            }
        } catch (err) {
            message.error(err.message);
        } finally {
            this.resetPasswordLoadingState = false;
        }
    }

}
export const loginStore = new LoginStore();



// WEBPACK FOOTER //
// ./src/models/LoginStore.ts